export const withThousandSeparator = (amount: number, separator: string) =>
  amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
